import { ChangeDetectionStrategy, Component, computed, effect, EventEmitter, HostBinding, input, model, Output, signal, ViewEncapsulation } from '@angular/core';
import { MediaType, SrcTypes, WireTypes } from '@discover/store/models/discover.models';

@Component({
    selector: 'st-wire-media',
    templateUrl: './wire-media.component.html',
    styleUrls: ['./wire-media.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        class: 'st-wire-media',
    },
})
export class WireMediaComponent {
    MediaType = MediaType;
    public wireType = model<MediaType>(MediaType.VIDEO);
    public mediaUrl = input<string>();

    public width = input<string>('180');
    public height = input<string>('180');
    public maxWidth = input<string>(null);
    public maxHeight = input<string>(null);
    shouldShowMedia = signal(true);
    @Output() public mediaClicked = new EventEmitter<string>();
    private firstLoad = true;
    public wireRecord = input<StorytellingWireRecord>();

    @HostBinding('style.width') hostWidth!: string;
    @HostBinding('style.height') hostHeight!: string;

    constructor() {
        effect(() => {
            this.hostWidth = `${this.width()}px`;
            this.hostHeight = `${this.height()}px`;
        });
    }

    hasAvailableMedia = computed(() => {
        const mediaType = this.mediaUrl().substring(this.mediaUrl().lastIndexOf('/') + 1);
        if (this.wireRecord().WireType === WireTypes.RssWire) {
            return true;
        }
        if (!mediaType) {
            return false;
        }
        switch (mediaType) {
            case SrcTypes.MainLink:
                if (this.wireRecord()?.Properties?.MainLink) {
                    return true;
                }
                return false;
            case SrcTypes.ThumbnailLink:
                if (this.wireRecord()?.Properties?.ThumbnailLink) {
                    return true;
                }
                return false;
            case SrcTypes.PreviewLink:
                if (this.wireRecord()?.Properties?.PreviewLink) {
                    return true;
                }
                return false;
            default:
                return true;
        }
    });

    openMedia() {
        this.mediaClicked.emit();
    }

    onMediaLoaded() {
        this.shouldShowMedia.set(true);
    }

    onMediaError() {
        if (this.firstLoad) {
            this.firstLoad = false;
            if (this.wireType() === MediaType.VIDEO) {
                this.wireType.set(MediaType.PICTURE);
            } else {
                this.wireType.set(MediaType.VIDEO);
            }
        } else {
            this.shouldShowMedia.set(false);
        }
    }
}
